// extracted by mini-css-extract-plugin
export default {"zoomModal":"Y3-z","image":"Z3-z","button":"_3-z","isOverlayShown":"a4-z"};